const COOKIE_CONSENT_KEY = "xphub_cookie_consent_v3";
const COOKIE_CONSENT_VERSION = 3;
const COOKIE_CONSENT_EVENT = "xphub:cookie-consent-changed";
const COOKIE_SETTINGS_EVENT = "xphub:open-cookie-settings";

function normalize(raw) {
  if (!raw || typeof raw !== "object") return null;

  return {
    version: COOKIE_CONSENT_VERSION,
    essential: true,
    analytics: Boolean(raw.analytics),
    ads: Boolean(raw.ads),
    preferences: Boolean(raw.preferences),
    updatedAt: Number(raw.updatedAt) || Date.now(),
    source: String(raw.source || "unknown"),
  };
}

export function readCookieConsent() {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);

    if (!parsed || typeof parsed !== "object") return null;
    if (Number(parsed.version) !== COOKIE_CONSENT_VERSION) return null;

    return normalize(parsed);
  } catch {
    return null;
  }
}

export function hasCookieDecision() {
  return Boolean(readCookieConsent());
}

export function saveCookieConsent(nextRaw) {
  const next = normalize({ ...nextRaw, version: COOKIE_CONSENT_VERSION });
  if (!next) return null;

  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(next));
  } catch {
    // noop
  }

  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_EVENT, { detail: next }));
  }

  return next;
}

export function getConsentSnapshot() {
  return (
    readCookieConsent() || {
      version: COOKIE_CONSENT_VERSION,
      essential: true,
      analytics: false,
      ads: false,
      preferences: false,
      updatedAt: 0,
      source: "unset",
    }
  );
}

export function hasAnalyticsConsent() {
  return Boolean(getConsentSnapshot().analytics);
}

export function hasPreferencesConsent() {
  return Boolean(getConsentSnapshot().preferences);
}

export function hasAdsConsent() {
  return Boolean(getConsentSnapshot().ads);
}

export function onCookieConsentChange(handler) {
  if (typeof window === "undefined" || typeof handler !== "function") {
    return () => {};
  }

  const listener = (event) => {
    handler(event?.detail || getConsentSnapshot());
  };

  window.addEventListener(COOKIE_CONSENT_EVENT, listener);
  return () => window.removeEventListener(COOKIE_CONSENT_EVENT, listener);
}

export function requestOpenCookieSettings() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(COOKIE_SETTINGS_EVENT));
}

export function onCookieSettingsRequested(handler) {
  if (typeof window === "undefined" || typeof handler !== "function") {
    return () => {};
  }

  const listener = () => handler();
  window.addEventListener(COOKIE_SETTINGS_EVENT, listener);
  return () => window.removeEventListener(COOKIE_SETTINGS_EVENT, listener);
}
